import {createContext} from 'react';
import {DrawerContextProps} from "./DrawerProvider.types";

export const DrawerContext = createContext<DrawerContextProps>(
    {} as DrawerContextProps
);
